import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * The bare `/evaltool/$studyId` has no view of its own.
 *
 * SimOps' equivalent renders whichever phase view matches the study's status,
 * because a SimOps study can be at any of them. Every study that reaches this
 * route is finished or waiting on a review decision (the layout's loader
 * forwards the rest to SimOps), and the surface for those is `/results` — so
 * the bare path resolves to it rather than rendering the study header over an
 * empty outlet, which is what it did before this file existed.
 *
 * A REPLACE, and search carried through, for the reasons `results/index.tsx`
 * gives for its own redirect.
 */
export const Route = createFileRoute('/_app/evaltool/$studyId/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/evaltool/$studyId/results',
      params: { studyId: params.studyId },
      search: (prev) => prev,
      replace: true,
    });
  },
});
